export default __webpack_public_path__ + "bd064eb795fd5c90a28ba6c1b519dba2.png";